// extracted by mini-css-extract-plugin
module.exports = {"block":"FreeUsageNotice_block__SzwqY","row":"FreeUsageNotice_row__LkG3e","glyph":"FreeUsageNotice_glyph__o2eCT"};